import { addIcon } from "@iconify/react";

import accountGroup from "@iconify-icons/mdi/account-group";
import accountGroupOutline from "@iconify-icons/mdi/account-group-outline";
import accountOutline from "@iconify-icons/mdi/account-outline";
import accountTie from "@iconify-icons/mdi/account-tie";
import alertCircle from "@iconify-icons/mdi/alert-circle";
import calendarMonthOutline from "@iconify-icons/mdi/calendar-month-outline";
import cancel from "@iconify-icons/mdi/cancel";
import chartAreaspline from "@iconify-icons/mdi/chart-areaspline";
import chartDonut from "@iconify-icons/mdi/chart-donut";
import chartLine from "@iconify-icons/mdi/chart-line";
import chartLineVariant from "@iconify-icons/mdi/chart-line-variant";
import chat from "@iconify-icons/mdi/chat";
import chatOutline from "@iconify-icons/mdi/chat-outline";
import chatProcessing from "@iconify-icons/mdi/chat-processing";
import checkCircle from "@iconify-icons/mdi/check-circle";
import circle from "@iconify-icons/mdi/circle";
import clockOutline from "@iconify-icons/mdi/clock-outline";
import cog from "@iconify-icons/mdi/cog";
import deleteIcon from "@iconify-icons/mdi/delete";
import eye from "@iconify-icons/mdi/eye";
import fileDocumentMultiple from "@iconify-icons/mdi/file-document-multiple";
import helpCircle from "@iconify-icons/mdi/help-circle";
import history from "@iconify-icons/mdi/history";
import hourglassEmpty from "@iconify-icons/mdi/hourglass-empty";
import inboxOutline from "@iconify-icons/mdi/inbox-outline";
import loading from "@iconify-icons/mdi/loading";
import messageOutline from "@iconify-icons/mdi/message-outline";
import pencil from "@iconify-icons/mdi/pencil";
import phone from "@iconify-icons/mdi/phone";
import plus from "@iconify-icons/mdi/plus";
import refresh from "@iconify-icons/mdi/refresh";
import robot from "@iconify-icons/mdi/robot";
import send from "@iconify-icons/mdi/send";
import whatsapp from "@iconify-icons/mdi/whatsapp";

const icons = {
  "mdi:account-group": accountGroup,
  "mdi:account-group-outline": accountGroupOutline,
  "mdi:account-outline": accountOutline,
  "mdi:account-tie": accountTie,
  "mdi:alert-circle": alertCircle,
  "mdi:calendar-month-outline": calendarMonthOutline,
  "mdi:cancel": cancel,
  "mdi:chart-areaspline": chartAreaspline,
  "mdi:chart-donut": chartDonut,
  "mdi:chart-line": chartLine,
  "mdi:chart-line-variant": chartLineVariant,
  "mdi:chat": chat,
  "mdi:chat-outline": chatOutline,
  "mdi:chat-processing": chatProcessing,
  "mdi:check-circle": checkCircle,
  "mdi:circle": circle,
  "mdi:clock-outline": clockOutline,
  "mdi:cog": cog,
  "mdi:delete": deleteIcon,
  "mdi:eye": eye,
  "mdi:file-document-multiple": fileDocumentMultiple,
  "mdi:help-circle": helpCircle,
  "mdi:history": history,
  "mdi:hourglass-outline": hourglassEmpty,
  "mdi:inbox-outline": inboxOutline,
  "mdi:loading": loading,
  "mdi:message-outline": messageOutline,
  "mdi:pencil": pencil,
  "mdi:phone": phone,
  "mdi:plus": plus,
  "mdi:refresh": refresh,
  "mdi:robot": robot,
  "mdi:send": send,
  "mdi:whatsapp": whatsapp,
};

for (const [name, data] of Object.entries(icons)) {
  addIcon(name, data);
}
